// Liste des pays/régions européennes
const europeanLocations = [
  'France',
  'UK',
  'United Kingdom',
  'Germany',
  'Switzerland',
  'Belgium',
  'Italy',
  'Spain',
  'Netherlands',
  'Portugal',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Ireland',
  'Poland',
  'Greece',
  'Czech Republic',
  'Hungary',
  'Romania',
  'Bulgaria',
  'Croatia',
  'Luxembourg',
  'Slovenia',
  'Slovakia',
  'Estonia',
  'Latvia',
  'Lithuania',
  'Malta',
  'Cyprus'
];

/**
 * Détermine la devise à utiliser selon la localisation du produit
 * @param {string} location - Localisation du produit (ex: "Paris, France")
 * @returns {string} - Code devise ('EUR' ou 'USD')
 */
export const getCurrencyByLocation = (location) => {
  if (!location) return 'EUR';  // Défaut EUR pour GEO TS CONSULTING (France)
  
  // Vérifie si la localisation contient un pays européen
  const isEuropean = europeanLocations.some(country => 
    location.includes(country)
  );
  
  return isEuropean ? 'EUR' : 'EUR';  // Toujours EUR par défaut
};

/**
 * Formate le prix avec la devise appropriée
 * @param {number} price - Prix à formatter
 * @param {string} currency - Code devise ('EUR' ou 'USD')
 * @returns {string} - Prix formatté avec symbole
 */
export const formatPrice = (price, currency = 'EUR') => {  // Défaut EUR
  if (!price) return '-';
  
  const symbol = currency === 'EUR' ? '€' : '$';
  const formattedPrice = price.toFixed(2);
  
  // EUR se met après le nombre, USD avant
  return currency === 'EUR' 
    ? `${formattedPrice}€` 
    : `$${formattedPrice}`;
};

/**
 * Obtient le symbole de la devise
 * @param {string} currency - Code devise ('EUR' ou 'USD')
 * @returns {string} - Symbole de la devise
 */
export const getCurrencySymbol = (currency) => {
  return currency === 'EUR' ? '€' : '$';
};
